import img from '../img/404.png';
import {useEffect, useState} from "react";
export default function NotFound() {

	return (
		<div style={{width:'100%', overflowY:'hidden'}}>
			<a href={"/"}><img src={img}  style={{width:'100%'}} /></a>
		</div>
	)
}
